import { Injectable } from '@angular/core';
import { CfetErrorMessagesConstant } from '../constants/cfet-error-messages.constant';
import { AdobeAnalyticsService } from '../core-services/Reporting/adobeAnalyticsService';

@Injectable({
    providedIn: 'root'
})
export class AdobeAnaltyticsUtil {

    constructor(private adobeAnalyticsService: AdobeAnalyticsService) { }

    /**
     * This method is for logging adobe data on Page Load
     * @param linkname Input parameter represents Link Name
     */
    adobeAnalyticsPageLoad(httpHeaders, desturl?: string, pageFriendlyName?: string) {
        const pageloadData = {
            'page.location.url': desturl,
            'page.pageInfo.friendlyPageName': pageFriendlyName,
            'page.category.siteSection': '',
            'page.category.siteSubSection1': '',
            'page.category.siteSubSection2': '',
            'page.pageInfo.flowCode': '',
            'page.category.pageFunction': '',
            'user.account.liabilityType': '',
            'user.login.id': httpHeaders.xuserid,
            'user.attributes.ABScompanyName': httpHeaders.userRoleGroup,
            'user.attuid': httpHeaders.xuserid
        };
        this.adobeAnalyticsService.sendPageLoadParams(pageloadData);
    }

    /**
     * This method is for tracking no of Link Cicks
     * @param linkname Input parameter represents Link Name
     */
    adobeAnalyticsLinkClickEvent(linkname?: string, desturl?: string) {
        const successEventData: any = {
            successflag: '1',
            eventAction: 'linkclick',
            statusmessage: '',
            errortype: '',
            linkname: linkname,
            linkPosition: 'Body',
            desturl: desturl,
            eventCode: ''
        };
        this.adobeAnalyticsService.sendCDLEvent(successEventData, '');
    }

    /**
     * This method is for logging adobe data for success event 
     * @param eventcode Input parameter represents Event Code
     * @param linkname Input parameter represents Link Name
     * @param desturl Input parametre represents Destination URL
     */
    adobeAnalyticsSuccessEvent(eventcode?: string, linkname?: string, desturl?: string) {
        const successEventData: any = {
            successflag: '1',
            eventAction: 'formResponse',
            statusmessage: 'Success',
            errortype: 'Success_Admit',
            linkname: linkname,
            linkPosition: 'Body',
            desturl: desturl,
            eventCode: eventcode
        };
        this.adobeAnalyticsService.sendCDLEvent(successEventData, '');
    }

    /**
     * This method is for logging adobe data for failure event 
     */
    adobeAnalyticsFailureEvent() {
        const failureEventData: any = {
            successflag: '0',
            eventAction: 'formResponse',
            statusmessage: CfetErrorMessagesConstant.CFET_DEFAULT_ERROR_MESSAGE,
            errortype: 'Failure_System',
            linkname: '',
            linkPosition: 'Body_Message',
            desturl: '',
            eventCode: 'Page_Alert_Display'
        };
        this.adobeAnalyticsService.sendCDLEvent(failureEventData, '');
    }
}
